import type { FC, KeyboardEvent } from 'react'

import type { ContactSearchResult } from '~/api/graphql/generated/types'

import { ClinicBrief } from './ClinicBrief'

import styles from './ClinicSearchCard.module.scss'

export interface ClinicSearchCardProps {
  contact: ContactSearchResult
  onClick: () => void
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void
}

const getContactAriaLabel = (contact: ContactSearchResult): string => {
  const parts = [contact.name ?? 'Unknown clinic name']
  const addressParts = [
    contact.address,
    contact.city,
    contact.state,
    contact.zip,
  ].filter(Boolean)
  if (addressParts.length > 0) {
    parts.push(addressParts.join(', '))
  }
  if (contact.phone) {
    parts.push(contact.phone)
  }
  return parts.join('. ')
}

const ClinicSearchCard: FC<ClinicSearchCardProps> = ({
  contact,
  onClick,
  onKeyDown,
}) => {
  const cardId = contact.kyriosId ?? crypto.randomUUID()

  return (
    <div
      aria-label={getContactAriaLabel(contact)}
      aria-selected={false}
      className={styles.clinicCard}
      id={cardId}
      role="option"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <ClinicBrief contact={contact} />
    </div>
  )
}

export default ClinicSearchCard
